var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 75,
    viewBox: "0 0 98 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7571 5.09176e-06L39.7571 27.918L25.4496 75L6.96383 75L17.4729 28.9827L-4.02296e-06 28.9827L-6.55671e-06 8.56743e-06L39.7571 5.09176e-06ZM98 0L98 27.918L83.8191 75L65.3333 75L75.7158 28.9826L58.2429 28.9827L58.2429 3.47568e-06L98 0Z",
    fill: "#252628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonImage);
export default __webpack_public_path__ + "static/media/commonImage.ab542716b2543cc42e2e1bbf7c132d09.svg";
export { ForwardRef as ReactComponent };